// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1v0jT","savePackageButton":"ClientWallet_savePackageButton__5c7Kn"};